module.exports = __webpack_public_path__ + "fonts/Myriad-Pro-Regular.7ac043ce.ttf";